import { TableEmptyState } from '@practium/ui';
import type { Group } from '../../../types';
import styles from '../SystemTable.module.css';

interface GroupsTableProps {
	groups: Group[];
	onRowClick?: (id: string) => void;
}

export const GroupsTable = ({ groups, onRowClick }: GroupsTableProps) => {
	if (groups.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum grupo encontrado"
				subtitle="Adicione um grupo de permissões para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Qtd. Hierarquias</th>
						<th>Última Alteração</th>
						<th>Criação</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{groups.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.hierarchyCount ?? '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.updatedAt}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.createdAt}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
